import { render, staticRenderFns } from "./filter-pricerange-setter.vue?vue&type=template&id=12dbec41"
import script from "./filter-pricerange-setter.vue?vue&type=script&lang=js"
export * from "./filter-pricerange-setter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports